import React from 'react';
import { nameRegExp, TextFieldForm, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';

import ToggleDisplayEditFormItem from '../../../../../components/ToggleDisplayEditFormItem';
import { CandidateProfilePersonalParticularsProps } from '../CandidateProfilePersonalParticulars';
import { useStyles } from '../styles';

const CandidateNameRelatedComponent = ({
  isEditState,
  formHook,
  isDisableInputs = undefined,
  isHideExtraFormInfo = false,
  formDefaultValues = undefined,
  formDefaultValuesViewDetails = undefined,
}: CandidateProfilePersonalParticularsProps) => {
  const { formState: { errors } } = formHook;
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        labelText={t('profile->>CreateCandidateForm.Name')}
        valueText={formDefaultValuesViewDetails?.name}
        id="candidateName"
        containerClassName={classes.formElementContainer}
        EditComponent={
          <>
            {!isHideExtraFormInfo && isEditState && (
              <Typography variant="subtitle1" className={classes.extraInfoText}>
                Please note that Name will be printed on your Exam Certificate.
              </Typography>
            )}
            <TextFieldForm
              form={formHook}
              isInputTextUpperCase
              onChange={(e) => formHook?.setValue('name', e.target.value.toUpperCase())}
              label={t('profile->>CreateCandidateForm.Name')}
              name="name"
              type="text"
              error={!!errors.name}
              helperText={errors?.name?.message?.toString()}
              fullWidth
              inputProps={{ readOnly: isDisableInputs?.name }}
              regExpToBlock={nameRegExp}
              isRequired
            />
          </>
        }
      />

      <ToggleDisplayEditFormItem
        isEditState={isEditState}
        labelText={t('profile->>CreateCandidateForm.Hanyu Pinyin Name')}
        allHide
        valueText={formDefaultValuesViewDetails?.hanyupinyinName}
        id="input-hanyupinyinName"
        containerClassName={isEditState ? classes.formElementContainer : classes.halfWidthRightItem}
        EditComponent={
          <TextFieldForm
              form={formHook}
            isInputTextUpperCase
            onChange={(e) => formHook?.setValue('hanyupinyinName', e.target.value.toUpperCase())}
            label={t('profile->>CreateCandidateForm.Hanyu Pinyin Name')}
            name="hanyupinyinName"
            type="text"
            id="input-hanyupinyinName"
            error={!!errors.hanyupinyinName}
            helperText={errors?.hanyupinyinName?.message?.toString()}
            fullWidth
            inputProps={{ readOnly: isDisableInputs?.hanyupinyinName }}
          />
        }
      />
    </>
  );
};

export default CandidateNameRelatedComponent;
